var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtInvestmentData = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 59,
    viewBox: "0 0 100 59",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8F1F3",
    d: "M0 32.692 56.837 0 100 25.426 43.646 59z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.716 5.138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.737 8.206c1.344 1.023 3.333 1.737 5.605 1.93.403.033.812.05 1.231.05 4.778 0 8.65-2.29 8.65-5.118 0-1.3-.818-2.485-2.169-3.391",
    fill: "#F8BA48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.17 8.509C.817 7.606 0 6.42 0 5.119 0 2.292 3.873 0 8.65 0c2.781 0 5.253.774 6.837 1.98",
    fill: "#F8C75F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.597 5.24 6.81-3.32c1.138.865 1.813 1.952 1.813 3.134 0 .781-.296 1.526-.828 2.189",
    fill: "#1C7792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.787 8.233 5.951-2.829.686.223-.077 4.579c-3.16.08-5.12-.879-6.298-1.758-.076-.057-.15-.114-.223-.171",
    fill: "#1F4B54"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E9F4F5",
    cx: 8.567,
    cy: 4.674,
    rx: 4.398,
    ry: 2.461
  })), /*#__PURE__*/React.createElement("path", {
    d: "m76.838 16.627 14.935 8.738c.232.148.475.094.532-.013.056-.108-.03-.34-.273-.462l-14.914-8.653c-.323-.142-.58-.169-.626-.085-.043.078.087.26.29.438M74.263 18.338l14.935 8.738c.232.148.475.094.532-.014.056-.108-.03-.34-.273-.461l-14.914-8.654c-.323-.141-.58-.168-.626-.084-.043.077.087.26.29.438M71.382 20.122l14.934 8.738c.233.148.476.095.533-.013.056-.108-.03-.34-.273-.462l-14.915-8.653c-.322-.142-.578-.169-.625-.084-.043.077.086.259.29.437M68.574 21.873l14.935 8.738c.232.148.475.094.532-.013.056-.108-.03-.34-.273-.462l-14.914-8.653c-.323-.142-.58-.169-.626-.084-.043.077.087.259.29.437M42.009 10.826l38.043 22.26.382.236c.12.171.08.404-.07.512a.36.36 0 0 1-.442-.037L50.09 16.264l-8.417-4.896c-.266-.142-.326-.428-.236-.556.08-.114.319-.151.529-.013M38.17 13.29l38.043 22.26.382.237c.12.171.08.404-.07.511a.36.36 0 0 1-.442-.037L46.25 18.728l-8.417-4.896c-.267-.141-.327-.427-.237-.555.08-.115.32-.152.53-.014M7.412 32.796l14.935 8.738c.233.149.476.095.532-.013.057-.108-.03-.34-.273-.461L7.692 32.406c-.323-.142-.58-.168-.626-.084-.043.077.087.259.29.437",
    fill: "#0D222A"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C7792",
    d: "m13.051 30.604 2.589 1.354 3.576-2.482-2.418-1.357z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "m16.595 32.537 2.365 1.387 5.16-3.313-2.432-1.151"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C7792",
    d: "m19.878 34.487 2.332 1.424 7.173-4.65-2.126-1.212"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "m23.265 36.48 2.336 1.425 7.172-4.65-2.129-1.213"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1C7792",
    d: "m29.935 40.339 2.665 1.495 18.638-12.805-3.46-1.741-18.362 12.738M38.795 45.609l2.532 1.508 15.823-10.02-2.948-1.415"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "m43.043 48.504 2.971 1.775L64.57 38.48l-3.457-1.666M34.287 42.83l2.971 1.779 18.554-11.802-3.457-1.667"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.146 14.24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.23 8.96v4.034c.173.303.43.72.782 1.189 3.89 5.168 11.222 5.646 13.357 5.687.71.013 9.988.064 14.539-6.014.1-.135.183-.25.236-.327l-.116-5.199",
    fill: "#595853"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#8B8B89",
    cx: 31.619,
    cy: 8.408,
    rx: 14.405,
    ry: 8.408
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#424240",
    cx: 31.735,
    cy: 8.088,
    rx: 12.12,
    ry: 6.829
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#636260",
    cx: 31.476,
    cy: 8.408,
    rx: 12.12,
    ry: 6.829
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.42 25.887 19.52-11.644c.276.057 1.347.31 2.136 1.34a3.725 3.725 0 0 1 .755 2.374l-.034.404L4.086 29.71",
    fill: "#61615F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#51524E",
    transform: "rotate(-39.88 2.68 27.978)",
    cx: 2.679,
    cy: 27.978,
    rx: 1.378,
    ry: 2.53
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#E9F4F5",
    cx: 31.413,
    cy: 9.597,
    rx: 11.484,
    ry: 5.64
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtInvestmentData);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-investment-data.260692ebb4d1183e5e544be96b96d6c4.svg";